"use client";

import { useRef } from "react";
import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";

import { ProductLineItemModel } from "@/lib/basket/productLineItem.model";

import { clearQuizData } from "@/app/blu/quiz/utils/quizStorage";
import { ProductReplaceKitModal } from "@/app/blu/shop/[slug]/components/productReplaceKitModel/productReplaceKitModal.component";
import { useAddToCartAnalytics } from "@/hooks/useAddToCartAnalytics";
import { GetProductQueryResult } from "@/sanity.types";

export const ConfiguratorSummaryActionClient = ({
  accessories,
  existingKits,
  kits,
  monitoring,
  product,
  quizResetSlug,
}: ConfiguratorSummaryActionClientProps) => {
  const { pending } = useFormStatus();
  const confirmationModal = useRef<HTMLDialogElement>(null);
  const fireAddToCartAnalytics = useAddToCartAnalytics({
    kits,
    accessories,
    monitoring,
  });
  const resetQuizData = () => {
    if (quizResetSlug) clearQuizData(quizResetSlug);
  };
  const submitAction = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const differentKit = existingKits?.find(
      (kit) => kit.productId !== product?.id,
    );
    // Check if the basket contains a different kit
    if (differentKit) {
      confirmationModal?.current?.showModal();
      return;
    }
    // Get product form
    const productForm = document.getElementById(
      "product-form",
    ) as HTMLFormElement;
    // Submit product form
    fireAddToCartAnalytics();
    resetQuizData();
    productForm?.requestSubmit();
  };
  return (
    <>
      <Button
        type="button"
        data-testid="configuration-summary-add-to-cart"
        secondary
        className="w-full"
        loading={pending}
        disabled={pending}
        onClick={submitAction}>
        Add To Cart
      </Button>
      <ProductReplaceKitModal
        ref={confirmationModal}
        onConfirm={() => {
          fireAddToCartAnalytics();
          resetQuizData();
        }}
      />
    </>
  );
};

export type ConfiguratorSummaryActionClientProps = {
  product: GetProductQueryResult;
  kits: ProductLineItemModel[];
  existingKits: ProductLineItemModel[];
  accessories: ProductLineItemModel[];
  monitoring: ProductLineItemModel | null;
  quizResetSlug?: string;
};
